export enum ConfigTypes {
  API_URL_BASE = 'REACT_APP_API_URL_BASE',
  EMBARK_CDN_BASE_URL = 'REACT_APP_EMBARK_CDN_BASE_URL',
  MY_EV_LEGACY_URL = 'REACT_APP_MY_EV_LEGACY_URL',
  CLOUDINARY_CLOUD_NAME = 'REACT_APP_CLOUDINARY_CLOUD_NAME',
  HEALTH_CONDITIONS_TESTED_FOR_COUNT = 'REACT_APP_HEALTH_CONDITIONS_TESTED_FOR_COUNT',
  FLAGSHIP_API_KEY = 'REACT_APP_FLAGSHIP_API_KEY',
  FLAGSHIP_ENV_ID = 'REACT_APP_FLAGSHIP_ENVIRONMENT_ID',
  CONTENTFUL_SPACE_ID = 'REACT_APP_CONTENTFUL_SPACE_ID',
  CONTENTFUL_API_KEY = 'REACT_APP_CONTENTFUL_API_KEY',
  CONTENTFUL_ENVIRONMENT = 'REACT_APP_CONTENTFUL_ENVIRONMENT',
  BASE_QUALTRICS_SURVEY_URL = 'REACT_APP_BASE_QUALTRICS_SURVEY_URL',
  QUALTRICS_ACTIVATION_SURVEY_TEMPLATE_ID = 'REACT_APP_QUALTRICS_ACTIVATION_SURVEY_TEMPLATE_ID',
}

type GetConfigReturn = string;

export function getConfig(key: ConfigTypes): GetConfigReturn {
  const value = process.env[key];

  if (!value) {
    throw new Error(`Missing required environment variable ${key}`);
  }

  return value;
}
